import { Component, OnInit } from '@angular/core';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { UserService } from 'src/services/user.service';
import { Observable } from 'rxjs/internal/Observable';
import { startWith } from 'rxjs/internal/operators/startWith';
import { map } from 'rxjs/operators';


@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit {
  /**
   * Variable que indica la pagina en la que te encuentras
   */
  p = 1;
  public usuarios = [];
  public documentId = null;
  public currentStatus = 1;
  public newUsuariForm = new FormGroup({
    nombre_usuar: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z\\s]+$')]),
    ape_pat_usuar: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z\\s]+$')]),
    ape_mat_usuar: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z\\s]+$')]),
    rut_usuar: new FormControl('', []),
    correo_user: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9]+\\.[a-zA-Z]{2,3}')]),
    cargo_usuar: new FormControl('', [Validators.required]),
    perfil_usuar: new FormControl('', [Validators.required]),
    password_user: new FormControl('', [Validators.required, Validators.minLength(8),
      Validators.pattern('^|[0-9]{1,8}||[a-zA-Z]{1,8}|'), Validators.maxLength(8)]),
    id: new FormControl('')
  });

  filteredPerfil: Observable<any[]>;
  filteredCargo: Observable<any[]>;

  /**
   * Opciones a mostrar en sexo
   */
  opcionesPerfil = [
    {
      nombre: 'Administrador'
    },
    {
      nombre: 'Estándar'
    },
  ];
  /**
   * Opciones a mostrar en Cargo
   */
  opcionesCargo = [
    {
      nombre: 'Educadora '
    },
    {
      nombre: 'Técnico '
    },
  ];

  constructor(private firestoreService: FirestoreService, private userService: UserService) {
    this.newUsuariForm.setValue({
      id: '',
      nombre_usuar: '',
      ape_pat_usuar: '',
      ape_mat_usuar: '',
      rut_usuar: '',
      correo_user: '',
      cargo_usuar: '',
      perfil_usuar: '',
      password_user: '',
    });
  }

  ngOnInit() {
    this.firestoreService.getUsuaris().subscribe(usuariosSnapshot => {
      this.usuarios = [];
      usuariosSnapshot.forEach((usuariosData: any) => {
        this.usuarios.push({
          id: usuariosData.payload.doc.id,
          data: usuariosData.payload.doc.data()
        });
        this.usuarios.sort((a, b) => {
          if (a.data.nombre_usuar) {
            return a.data.nombre_usuar.localeCompare(b.data.nombre_usuar);
          }
          return;
        });
      });
    });
    this.filtroCargo();
    this.filtroPerfil();
  }

  filtroPerfil() {
    this.filteredPerfil = this.newUsuariForm.controls.perfil_usuar.valueChanges.pipe(
      startWith(''),
      // map(value => typeof value === 'string' ? value : value.nombre),
      map(name => name ? this._filterPerfil(name) : this.opcionesPerfil.slice())
    );
  }

  filtroCargo() {
    this.filteredCargo = this.newUsuariForm.controls.cargo_usuar.valueChanges.pipe(
      startWith(''),
      // map(value => typeof value === 'string' ? value : value.nombre),
      map(name => name ? this._filterCargo(name) : this.opcionesCargo.slice())
    );
  }

  limpiar() {
    this.newUsuariForm.reset();
  }

  private _filterPerfil(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.opcionesPerfil.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);
  }

  private _filterCargo(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.opcionesCargo.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);
  }


  public newusuarios(form, documentId = this.documentId) {
    // console.log(`Status: ${this.currentStatus}`);
    // console.log('FormData: ', form);
    // let user = JSON.parse(sessionStorage.getItem('usuario'));
    if (this.currentStatus === 1) {
      const data = {
        nombre_usuar: form.nombre_usuar,
        ape_pat_usuar: form.ape_pat_usuar,
        ape_mat_usuar: form.ape_mat_usuar,
        rut_usuar: form.rut_usuar,
        correo_user: form.correo_user,
        cargo_usuar: form.cargo_usuar,
        perfil_usuar: form.perfil_usuar,
      };
      this.userService.signup(form.correo_user, form.password_user, data).then(
        () => {
          console.log('Documento creado exitósamente!');
          this.newUsuariForm.reset();
          Swal.fire(
            'Creado!',
            'El registro se creo correctamente.',
            'success'
          );
        },
        error => {
          Swal.fire(
            'Error en la creacion',
            error.message,
            'error'
          );
          console.error(error);
        }
      );
      // this.firestoreService.createUsuari(registro.uid, data).then(
      //   () => {
      //     console.log('Documento creado exitósamente!');
      //     this.newUsuariForm.reset();
      //   },
      //   error => {
      //     console.error(error);
      //   }
      // );
    } else {
      form.correo_user = this.newUsuariForm.controls.correo_user.value;
      const data = {
        nombre_usuar: form.nombre_usuar,
        ape_pat_usuar: form.ape_pat_usuar,
        ape_mat_usuar: form.ape_mat_usuar,
        rut_usuar: form.rut_usuar,
        correo_user: form.correo_user,
        cargo_usuar: form.cargo_usuar,
        perfil_usuar: form.perfil_usuar,
      };

      this.firestoreService.updateUsuari(documentId, data).then(
        () => {
          this.currentStatus = 1;
          this.newUsuariForm.reset();
          this.newUsuariForm.controls.correo_user.enable();
          this.newUsuariForm.controls.password_user.enable();
          Swal.fire(
            'Editado!',
            'El registro se edito correctamente.',
            'success'
          );
        },
        error => {
          console.log(error);
        }
      );
    }
  }

  public editUsuari(documentId) {
    this.newUsuariForm.controls.correo_user.disable();
    this.newUsuariForm.controls.password_user.disable();
    const editSubscribe = this.firestoreService.getUsuari(documentId).subscribe((usuario) => {
      this.currentStatus = 2;
      this.documentId = documentId;
      this.newUsuariForm.setValue({
        id: documentId,
        nombre_usuar: usuario.payload.data()['nombre_usuar'],
        ape_pat_usuar: usuario.payload.data()['ape_pat_usuar'],
        ape_mat_usuar: usuario.payload.data()['ape_mat_usuar'],
        rut_usuar: usuario.payload.data()['rut_usuar'],
        correo_user: usuario.payload.data()['correo_user'],
        cargo_usuar: usuario.payload.data()['cargo_usuar'],
        perfil_usuar: usuario.payload.data()['perfil_usuar'],
        password_user: '*******',
      });
      editSubscribe.unsubscribe();
    });
  }

  public delUsuari(documentId) {

    Swal.fire({
      title: 'Estas seguro?',
      text: 'No podrás revertir esta accion!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, borrar!'
    }).then((result) => {
      if (result.value) {
        this.firestoreService.deleteUsuari(documentId).then(() => {
          Swal.fire(
            'Borrado!',
            'El registro fue eliminado.',
            'success'
          );
        }, (error) => {
          console.error(error);
        });
      }
    });

  }
}

